import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";
import { useJsonLd } from "@/lib/jsonld";

export const FaqSection = ({ content }) => {
  const items = content.items || [];
  useJsonLd(
    items.length
      ? {
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: items.map((it) => ({
            "@type": "Question",
            name: it.question,
            acceptedAnswer: { "@type": "Answer", text: it.answer },
          })),
        }
      : null
  );
  if (!items.length) return null;

  return (
    <section className="py-16 bg-background" data-testid="faq-section">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        {content.eyebrow && (
          <p className="text-xs font-mono uppercase tracking-[0.25em] text-primary mb-2">{content.eyebrow}</p>
        )}
        <h2 className="font-display text-2xl sm:text-3xl font-extrabold uppercase tracking-tight text-foreground mb-8">
          {content.heading}
        </h2>
        <Accordion type="single" collapsible className="w-full">
          {items.map((item, i) => (
            <AccordionItem key={i} value={`faq-${i}`} className="border-border" data-testid={`faq-item-${i}`}>
              <AccordionTrigger className="text-left text-foreground font-medium hover:text-primary">
                {item.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground leading-relaxed">
                {item.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
